/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Grid_View_TitleInputs */



/**
* | output |
* | --- |
* | "Grid view" |
*
* @param {Speakers_Grid_View_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_grid_view_title = /** @type {((inputs?: Speakers_Grid_View_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Grid_View_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vue en grille")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rasteransicht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizzazione griglia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сеточный вид")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista de cuadrícula")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("网格视图")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グリッドビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जालक दृश्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Visualização em grade")
	return /** @type {LocalizedString} */ ("Grid view")
});